var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.6 384.66",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.56,164.43a189.68,189.68,0,0,0-21.62-65,191.85,191.85,0,0,0-43.56-53.81,180.57,180.57,0,0,0-48.3-30.42C252.4,7.77,234.28,2,215,.65,212,.45,209,.92,206.1,0H177.6c-4.15.81-8.4.46-12.58,1a190.13,190.13,0,0,0-64.08,21.12,192.09,192.09,0,0,0-53.35,42.5C27,88,13,115,5.24,145.19c-5.71,22.08-6,44.55-4.42,67,1.66,23.7,8.86,46.11,19.62,67.24a193.23,193.23,0,0,0,40.19,53.27,198.37,198.37,0,0,0,57.47,37.45c30.34,13.2,62.22,16.29,94.73,13.67,27.81-2.24,53.7-11.31,77.73-25.45a194.1,194.1,0,0,0,90.81-125.84c1.8-8.18,2.38-16.49,3.23-24.77V177C383.79,172.85,384.13,168.61,383.56,164.43ZM192.17,357.13c-91.38-.5-165-74.49-164.69-165.47C27.8,100.4,101.86,26.59,192.84,26.87c91.44.28,165.38,74.56,164.88,165.65C357.23,283.86,283,357.62,192.17,357.13ZM212.26,220c0,15.37-.13,30.74.07,46.1a10.93,10.93,0,0,1-5.91,10.44c-8.78,5-17.83,5.2-26.79.54-4.41-2.3-6.61-5.91-6.58-11.23.15-30.1.07-60.21.07-90.32,0-8.8,2.69-12.35,11.33-14.49,7.23-1.79,14.39-1.47,21.18,1.81,4.38,2.11,6.75,5.45,6.69,10.68C212.14,189.05,212.26,204.54,212.26,220Zm-19.7-83.31a21,21,0,0,1-15.52-6.3c-7.18-7.29-6.76-17.77.93-24.47a22.66,22.66,0,0,1,28.06-.81c9.15,7.11,9.32,19.38.37,26.75A21.34,21.34,0,0,1,192.56,136.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.b64aa476437d8cfc772b39e697037630.svg";
export { ForwardRef as ReactComponent };